import {useTranslation} from 'hooks/translations/useCustomTranslation';
import React from 'react';

import {SxProps} from '@mui/material';

import {Group} from 'lib/api/backend.schemas';

import {palette} from 'styles/mui/scss';

import {Box, Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';
import StromInclusivePopup from 'components/basic-components/StromInclusivePopup/StromInclusivePopup';

import styles from './VehicleFlags.module.scss';

const PremiumFlag = ({sx}: {sx?: SxProps}) => {
  const {t} = useTranslation('common');

  return (
    <Box sx={sx} style={{zIndex: 2}}>
      <Box
        className={styles.vehicleFlag}
        sx={{
          backgroundColor: palette.colorPrimary,
          color: palette.colorBlack,
        }}
      >
        <CustomIcon name="star" className={styles.icon} />
        <Typography className={styles.chipText}>{t('premium')}</Typography>
      </Box>
    </Box>
  );
};

const ElectroFlag = ({sx, powerInclusive}: {sx?: SxProps; powerInclusive?: boolean}) => {
  const {t} = useTranslation('common');

  return (
    <Box sx={sx} style={{zIndex: 2}}>
      <Box
        className={styles.vehicleFlag}
        sx={{
          backgroundColor: palette.colorElectro,
          color: palette.colorWhite,
        }}
      >
        <CustomIcon name="electro" className={styles.icon} />
        <Typography className={styles.chipText}>
          {`${t('electro')} ${powerInclusive ? t('powerInclusive') : ''}`}
        </Typography>
      </Box>
    </Box>
  );
};

const LowAvailabilityFlag = ({sx}: {sx?: SxProps}) => {
  const {t} = useTranslation('common');

  return (
    <Box sx={sx} style={{zIndex: 2}}>
      <Box
        className={styles.vehicleFlag}
        sx={{
          backgroundColor: palette.colorPrimary,
          color: palette.colorBlack,
        }}
      >
        <CustomIcon name="clock" className={styles.icon} />
        <Typography className={styles.chipText}>{t('lowAvailability')}</Typography>
      </Box>
    </Box>
  );
};

const VehicleFlags = ({group, sx, oneWay}: {group: Group; sx?: SxProps; oneWay?: boolean}) => {
  return (
    <Box sx={sx} className={styles.vehicleFlagsBox}>
      {group?.premiumGroup && <PremiumFlag />}
      {group?.electro && group?.powerInclusive && (
        <StromInclusivePopup>
          <ElectroFlag powerInclusive={group.powerInclusive} />
        </StromInclusivePopup>
      )}
      {group?.electro && !group?.powerInclusive && (
        <ElectroFlag powerInclusive={group.powerInclusive || false} />
      )}
      {oneWay && group?.lowAvailability && group?.truck && <LowAvailabilityFlag />}
    </Box>
  );
};

export default VehicleFlags;
